import NextHeadTag from '@ui/molecules/NextHeadTag';
import { HeadTagData } from '@helpers/headTagData';
import ReferAndEarn from '@components/ReferAndEarn';

const ReferAndEarnPage = () => {
    return (
        <>
            <NextHeadTag {...HeadTagData['/referral-program']} />
            <ReferAndEarn />
        </>
    );
};

export const getServerSideProps = async (ctx) => {
    try {
        const auth = ctx.req.cookies.AUTH;
        
        if (auth) {
            return {
                redirect: {
                    destination: `/refer-and-earn`,
                    permanent: false,
                },
            };
        }
        return { props: {} };
    } catch (e) {
        return { props: {} };
    }
};

export default ReferAndEarnPage;
